import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { DateUtilsService } from '../../services/date-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { LoadingController, AlertController, NavController, IonModal, ModalController, IonContent } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Capacitor } from '@capacitor/core';
import { environment } from './../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { NgxCroppedEvent } from '../../component/ngx-photo-editor/ngx-photo-editor.component';
import { FileCameraComponent } from '../../component/file-camera/file-camera.component';
import { ReportAbuseComponent } from '../../component/report-abuse/report-abuse.component';
import { DataURIToBlob, blobToBase64 } from '../../utils'
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { ChatMessage } from '../../models/ia';
import { Animal, AnimalWeight, AnimalVaccineValence, AnimalVaccine } from '../../models/animal';
import { NetworkService } from '../../services/network.service';
import { AnimalService } from '../../services/animal.service';
import { VaccineService } from '../../services/vaccine.service';
import { IaService } from '../../services/ia.service';
import { VaccineLabel } from '../../models/vaccine';
import { Location } from '@angular/common';
import { ClinicContact } from '../../models/clinic';
import { ClinicService } from '../../services/clinic.service';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SpeechRecognition } from "@capacitor-community/speech-recognition";
import { TextToSpeech } from '@capacitor-community/text-to-speech';

@Component({
  selector: 'emergency',
  templateUrl: './emergency.component.html',
  styleUrls: ['./emergency.component.scss'],
  imports: [CommonModule, IonicModule, TranslateModule, FormsModule, ReactiveFormsModule, ReportAbuseComponent],
})
export class EmergencyComponent  implements OnInit {
  @ViewChild('modalEmergency', { static: false }) modalEmergency!: IonModal;
  @ViewChild('content', { static: false }) content!: IonContent;

  clinicContacts: ClinicContact[] | null = null;

  editorOptions = {
    toolbar: false,
  };

  chatMessages: ChatMessage[] | null = null;
  formChat: FormGroup = this.fb.group({ msg: ['', [Validators.required, ]], })
  public isSubmittedChat: boolean = false;
  loading: HTMLIonLoadingElement | null = null;

  isSpeechRecognitionAvailable: boolean = false;
  speechRecognitionLatestResultDate: Date = new Date();
  speechRecognitionResult: string = '';
  speechRecognitionIsCancel: boolean = false;

  isVoiceActivated: boolean = false;
  isVoiceRunning: boolean = false;

  constructor(
      public http: HttpClient,
      public dateUtils: DateUtilsService,
      private authService: AuthService,
      private navCtrl: NavController,
      public loadingController: LoadingController,
      public translate: TranslateService,
      public fb: FormBuilder,
      public alertController: AlertController,
      private activatedRoute: ActivatedRoute,
      public userService: UserService,
      public networkService: NetworkService,
      public animalService: AnimalService,
      public vaccineService: VaccineService,
      public clinicService: ClinicService,
      public iaService: IaService,
      private location: Location,
      private modalController: ModalController,
      private router: Router) {
  }

  async ngOnInit() {
    this.isSpeechRecognitionAvailable = Capacitor.getPlatform() !== 'web' && (await SpeechRecognition.available()).available
  }
  
  ionViewDidEnter() {
  }

  present() {
    this.modalEmergency.present()
    this.authService.getIsLoggedIn().then(data => {
      if(!this.authService.isLoggedIn) {
        this.router.navigate(['/login']);
        return
      }
      
      if(this.userService.user) {
        this.clinicService.dbGetClinicContactsOfUser(false, this.userService.user.id).then((data: ClinicContact[] | null) => {
          this.clinicContacts = data;
        });
        
        this.iaService.dbGetChatMessagesOfUser(this.userService.user.id).then((data: ChatMessage[] | null) => {
          this.chatMessages = data;
          this.scrollToBottom()
          setTimeout(() => { this.scrollToBottom() }, 50)
        });
      }
    });
  }


  closeModal(event: any) {
    this.modalController.dismiss();
    event.preventDefault();
  }

  closeModalAndAddVet(event: any) {
    this.closeModal(event)
    this.router.navigate(['clinic-contact-update']);
  }

  async presentLoading() {
    if(this.loading)
      this.stopLoading();

    this.loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: this.translate.instant('Please wait...'),
      duration: 20000
    });
    await this.loading.present();
  }

  stopLoading() {
    this.loading?.dismiss();
    this.loading = null;
  }

  msgAddCB() {
      this.isSubmittedChat = true;
  
      if(this.formChat.get('msg')?.value) {
        let chatMessage = new ChatMessage();
        chatMessage.userId = this.userService.user?.id ?? 0
        chatMessage.message = this.formChat.get('msg')?.value
        chatMessage.date = this.dateUtils.toStringIso(new Date())

        this.iaService.chatMessages.push(chatMessage);

        this.presentLoading()
        this.iaService.dbSendChatMessage(chatMessage).then((data: any) => {
        }).finally(async () => {
          this.chatMessages?.push(chatMessage);
          this.stopLoading();
          this.formChat.controls['msg'].setValue('');
          
          setTimeout(() => { this.scrollTo('iachat__message__' + chatMessage.id) }, 50)

          if(this.isVoiceActivated) {
            TextToSpeech.stop();
            this.isVoiceRunning = true;
            await TextToSpeech.speak({
              text: this.stripHtmlRegex(chatMessage.response),
              lang: 'fr-FR',
              rate: 1.2,
              pitch: 1.0,
              volume: 0.5,
              category: 'ambient',
              queueStrategy: 1
            });
            this.isVoiceRunning = false;
          }
        });
      }
      return true;
  }
  
  scrollTo(id: string = '') {
    try {
      const anchor = document.getElementById(id);
      this.content.scrollByPoint(0, (anchor?.getBoundingClientRect().top ?? 0) - 100, 0);
    } catch (err) {
      console.error('Erreur lors du scroll vers le bas :', err);
    }
  }
  
  scrollToBottom() {
    try {
      this.content.scrollToBottom(300);
    } catch (err) {
      console.error('Erreur lors du scroll vers le bas :', err);
    }
  }

  async speechRecognitionStartCB() {
    await SpeechRecognition.requestPermissions()

    var c = await this.alertController.create({
      header: this.translate.instant('Voice recognition'),
      message: this.translate.instant('Recording your question in progress...'),
      buttons: [
        { text: this.translate.instant('Cancel'), handler: async (d) => {
          this.speechRecognitionIsCancel = true
        } },
      ]
    })
    await c.present();

    this.speechRecognitionLatestResultDate = new Date()
    this.speechRecognitionIsCancel = false
    this.speechRecognitionResult = ''
    this.voiceStop();

    SpeechRecognition.start({
      language: 'fr-FR',
      maxResults: 5,
      prompt: '',
      partialResults: true,
    });

    SpeechRecognition.addListener("partialResults", (data: any) => {
      this.speechRecognitionResult = data.matches[0]
      this.formChat.get('msg')?.setValue(this.speechRecognitionResult);
      this.speechRecognitionLatestResultDate = new Date()
    });

    SpeechRecognition.addListener("listeningState", (data: any) => {
      c.dismiss();
      if(!this.speechRecognitionIsCancel) {
        this.msgAddCB()
      }
      else {
        this.formChat.controls['msg'].setValue('');
      }
      SpeechRecognition.removeAllListeners();
    });

    setTimeout(() => { this.speechRecognitionCheckIsFinish(); }, 100)
  }

  speechRecognitionCheckIsFinish() {
    if(this.speechRecognitionIsCancel || (this.speechRecognitionResult.length > 0 && (new Date()).getTime() - this.speechRecognitionLatestResultDate.getTime() > 800)) {
      SpeechRecognition.stop();
    } else {
      setTimeout(() => { this.speechRecognitionCheckIsFinish(); }, 100)
    }
  }

  voiceStop() {
    this.isVoiceRunning = false;
    TextToSpeech.stop();
  }

  voiceReverseCB() {
    this.voiceStop()
    this.isVoiceActivated= !this.isVoiceActivated
  }

  stripHtmlRegex(html: string): string {
    return html.replace(/<[^>]*>/g, '');
  }
}
